import { useAtomValue } from "jotai";

import { debugMessageOffsetVar, messagesVar } from "@/variables/globalVar";

export function useMessages() {
  const messages = useAtomValue(messagesVar);
  const debugMessageOffset = useAtomValue(debugMessageOffsetVar);

  return { messages: messages?.slice(0, messages.length - debugMessageOffset) };
}
